import { render, staticRenderFns } from "./ActivateCustomerForm.vue?vue&type=template&id=9a6ff4b0&"
import script from "./ActivateCustomerForm.vue?vue&type=script&lang=ts&"
export * from "./ActivateCustomerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports